import AdminAddPasein from "../../components/AdminInvoice/InvoiceAdd";

export default function AddPasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminAddPasein/>
    </div>
  );
}
